import { useEffect } from 'react';
import Lottie from 'lottie-react';
import confetti from '../../lottie/lottie.json';
import Cta from './Cta';

/* Congrats popup shown after the ₹10k card-spend reward is claimed. A card with
   a colored banner and a celebratory Lottie. Copy can be driven by the claim
   response (`title` / `message` / `ctaText`) with celebratory defaults. */
export default function SpendClaimPopup({ open, data, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const d = data || {};
  const title = d.title || 'Congratulations!';
  const message = d.message
    || 'Your reward has been claimed. Super Coins are on the way — keep spending on your GoSats card to earn even more.';

  return (
    <div className="bbd-popup-scrim" onClick={onClose}>
      <div className="bbd-cpop" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        <div className="bbd-cpop-banner" />

        <Lottie className="bbd-cpop-lottie" animationData={confetti} loop />

        <h2 className="bbd-cpop-title">{title}</h2>
        <p className="bbd-cpop-msg">{message}</p>

        <Cta label={d.ctaText || 'Done'} hideArrow className="bbd-cta-purple" onClick={onClose} />
      </div>
    </div>
  );
}
